// CausalChainGraph.jsx — Causal chain flow visualization
// Extracted from HypothesisExplorer for modularity.
//
// Usage: <CausalChainGraph chain={detail.causal_chain} color={detail.color} />

const C_BG = "#07070a";

export default function CausalChainGraph({ chain, color }) {
  const count = chain.length;
  if (count === 0) return null;

  return (
    <div style={{ position: "relative" }}>
      <div className="rr-hyp-chain-flow" style={{
        display: "flex", alignItems: "stretch", gap: 0,
        overflowX: "auto", padding: "8px 0",
      }}>
        {chain.map((stage, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", flex: "1 1 0", minWidth: 200 }}>
            {/* Stage card */}
            <div style={{
              flex: "1 1 0",
              padding: "20px 18px 16px",
              background: `linear-gradient(180deg, ${color}08 0%, rgba(255,255,255,0.015) 100%)`,
              border: `1px solid ${color}30`,
              borderRadius: 8,
              position: "relative",
              overflow: "hidden",
              minHeight: 170,
              display: "flex",
              flexDirection: "column",
            }}>
              {/* Stage number node */}
              <div style={{
                display: "flex", alignItems: "center", gap: 12, marginBottom: 14,
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: `linear-gradient(135deg, ${color}, ${color}aa)`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: C_BG, fontSize: 16, fontWeight: 700,
                  fontFamily: "'IBM Plex Mono', monospace",
                  boxShadow: `0 0 16px ${color}40`,
                  flexShrink: 0,
                }}>
                  {stage.n}
                </div>
                <div style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  fontSize: 17, fontWeight: 700, color: "#e8e8f0",
                  lineHeight: 1.2, letterSpacing: "-0.005em",
                }}>
                  {stage.signal}
                </div>
              </div>

              {/* Source */}
              <div style={{
                fontSize: 13, color: "rgba(232,232,240,0.80)", lineHeight: 1.5,
                fontFamily: "'IBM Plex Mono', monospace",
                flex: 1,
              }}>
                {stage.source}
              </div>

              {/* Lag bar */}
              <div style={{
                marginTop: 14, paddingTop: 12,
                borderTop: `1px solid ${color}18`,
                display: "flex", alignItems: "center", gap: 10,
              }}>
                <div style={{
                  height: 4, borderRadius: 2, flex: 1,
                  background: `linear-gradient(90deg, ${color}55, ${color}15)`,
                  position: "relative", overflow: "hidden",
                }}>
                  <div style={{
                    position: "absolute", left: 0, top: 0, bottom: 0,
                    width: `${Math.min(100, (i + 1) / count * 100)}%`,
                    background: color, borderRadius: 2,
                    opacity: 0.7,
                  }} />
                </div>
                <span style={{
                  fontSize: 12, fontWeight: 700, color,
                  letterSpacing: "0.08em",
                  fontFamily: "'IBM Plex Mono', monospace",
                  whiteSpace: "nowrap",
                }}>
                  {stage.lag.toUpperCase()}
                </span>
              </div>
            </div>

            {/* Arrow connector */}
            {i < count - 1 && (
              <div style={{
                width: 40, flexShrink: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <svg width="40" height="24" viewBox="0 0 40 24" fill="none">
                  <line x1="2" y1="12" x2="28" y2="12" stroke={color} strokeWidth="1.5" strokeOpacity="0.5" />
                  <polyline points="24,6 32,12 24,18" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.7" />
                  <circle cx="14" cy="12" r="2.5" fill={color} opacity="0.6">
                    <animate attributeName="opacity" values="0.6;0.15;0.6" dur="2s" repeatCount="indefinite" />
                    <animate attributeName="cx" values="6;28;6" dur="3s" repeatCount="indefinite" />
                  </circle>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Timeline bar underneath */}
      <div style={{
        margin: "10px 0 0",
        height: 3, borderRadius: 2,
        background: `linear-gradient(90deg, ${color}40, ${color}08)`,
        position: "relative",
      }}>
        {chain.map((_, i) => (
          <div key={i} style={{
            position: "absolute",
            left: `${(i / (count - 1 || 1)) * 100}%`,
            top: -3, width: 9, height: 9,
            borderRadius: "50%",
            background: C_BG,
            border: `2px solid ${color}`,
            transform: "translateX(-50%)",
            opacity: 0.7,
          }} />
        ))}
      </div>
    </div>
  );
}
